// extracted by mini-css-extract-plugin
export default {"commentsContainer":"Comments_commentsContainer__CYX3k","commentItemContainer":"Comments_commentItemContainer__4Jvsw","data":"Comments_data__EMObF"};